/**
 * authedFileUrl — append the current auth token as a query parameter to a private
 * upload URL so it can be loaded by <img>, <iframe>, or a "VIEW" new-tab link
 * (contexts that cannot inject an Authorization header).
 *
 * Public asset paths (avatars, listing photos, etc.) can also be run through this
 * safely — the token is simply ignored server-side when the path is not a member-doc.
 *
 * Returns the URL unchanged if the input is falsy or already has a query string
 * containing `access_token=`.
 */
export function authedFileUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (/[?&]access_token=/.test(url)) return url;
  const token = localStorage.getItem("pjp_token");
  if (!token) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}access_token=${encodeURIComponent(token)}`;
}
